import { browserStore } from "./storageKeys";

// Signals that an authenticated Ediphi API call was rejected with a 401 — the session token has been
// revoked (logging out of the web app revokes ALL of a user's tokens, including the one the add-in
// scraped) or has expired. The shared api client dispatches this; App listens for it and routes the
// user back to a clean login (DO-730).
//
// A DOM CustomEvent is used so the api/util layer stays free of React and of error logging (per
// docs/error-handling-and-logging.md): it only broadcasts the fact, and App owns the re-login UX.
export const SESSION_EXPIRED_EVENT = "ediphi:session-expired";

/** Whether there's an Ediphi session to make API calls with. */
export const hasSession = (): boolean => Boolean(browserStore.get("xAuthToken"));

export const notifySessionExpired = (): void => {
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
};
